/**
 * @generated SignedSource<<a9b72bb7741eeb4e0727bf404206ddd9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useNativeCollabFragment_content$data = Result<{
  readonly history: {
    readonly createdBy: {
      readonly displayName: string | null;
    } | null;
    readonly createdDate: string | null;
  } | null;
  readonly id: string | null;
  readonly labels: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly homepageId: string | null;
    readonly id: string | null;
    readonly name: string | null;
  } | null;
  readonly status: string | null;
  readonly subType: string | null;
  readonly type: string | null;
  readonly version: {
    readonly by: {
      readonly accountId?: string | null;
      readonly type: string | null;
    } | null;
    readonly ncsStepVersion: string | null;
    readonly number: number | null;
  } | null;
  readonly " $fragmentType": "useNativeCollabFragment_content";
}, unknown>;
export type useNativeCollabFragment_content$key = {
  readonly " $data"?: useNativeCollabFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNativeCollabFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "type"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useNativeCollabFragment_content",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "number"
        },
        {
          "kind": "ScalarField",
          "name": "ncsStepVersion"
        },
        {
          "kind": "LinkedField",
          "name": "by",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                }
              ],
              "type": "KnownUser"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "displayName"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "createdDate"
        }
      ]
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "kind": "ScalarField",
          "name": "homepageId"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "ASCENDING",
            "sortField": "LABELLING_CREATIONDATE"
          }
        }
      ],
      "concreteType": "PaginatedLabelList",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/)
          ]
        }
      ],
      "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "3994f3699b8e303fdbf69b3faf07991a";

export default node;
